import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './PlaceholderTab.css';

const PlaceholderTab: FC = () => {
    const {t} = useTranslation('timetable');
    return <css.placeholder>{t('comingSoon')}</css.placeholder>;
};

export default PlaceholderTab;
